import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Stack } from '@hub/stack';
import { IconButton } from '@hub/button';
import { GridViewMediumIcon, ListViewMediumIcon } from '@hub/icon';
import React, { useState } from 'react';
import { useRouter } from '../../next/router';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const isViewType = value => {
  return typeof value === 'string' && ['auto', 'list', 'grid'].includes(value);
};
export const useViewControlWithRouter = defaultValue => {
  const router = useRouter();
  const {
    0: state,
    1: setState
  } = useState(() => {
    const storedViewValue = router.query.viewMode || defaultValue || 'auto';
    return storedViewValue;
  });
  const setViewMode = value => {
    setState(value);
    router.push({
      pathname: router.pathname,
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        viewMode: value
      })
    }, undefined, {
      shallow: true
    });
  };
  return [state, setViewMode];
};
export const ViewControl = _ref => {
  let {
    value,
    onChange,
    sx
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "row",
    sx: sx,
    "data-id": "view-control_index_ViewControl_Stack",
    children: [/*#__PURE__*/_jsx(IconButton, {
      variant: "plainIcon",
      size: "md",
      sx: {
        color: value === 'auto' ? ['manatee', null, 'licorice'] : value === 'grid' ? 'licorice' : 'manatee'
      },
      icon: /*#__PURE__*/_jsx(GridViewMediumIcon, {
        boxSize: "size-icon-md",
        "data-id": "view-control_index_ViewControl_GridViewMediumIcon"
      }),
      onClick: () => onChange('grid'),
      "aria-label": "Set to grid view",
      "data-id": "view-control_index_ViewControl_Stack_IconButton"
    }), /*#__PURE__*/_jsx(IconButton, {
      variant: "plainIcon",
      size: "md",
      sx: {
        color: value === 'auto' ? ['licorice', null, 'manatee'] : value === 'list' ? 'licorice' : 'manatee'
      },
      icon: /*#__PURE__*/_jsx(ListViewMediumIcon, {
        boxSize: "size-icon-md",
        "data-id": "view-control_index_ViewControl_ListViewMediumIcon"
      }),
      onClick: () => onChange('list'),
      "aria-label": "Set to list view",
      "data-id": "view-control_index_ViewControl_Stack_IconButton"
    })]
  });
};